export default __webpack_public_path__ + "static/media/mon_24.cc977298.png";